export const FileIcon = () => {
  return (
    <svg
      width='24'
      height='28'
      viewBox='0 0 24 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0.664062 11.3337C0.664062 6.30534 0.664062 3.79119 2.32379 2.22909C3.98352 0.666992 6.65481 0.666992 11.9974 0.666992H13.0277C17.376 0.666992 19.5501 0.666992 21.06 1.73077C21.4926 2.03556 21.8766 2.39703 22.2005 2.80418C23.3307 4.22522 23.3307 6.27147 23.3307 10.364V13.7579C23.3307 17.7088 23.3307 19.6842 22.7055 21.262C21.7003 23.7984 19.5745 25.7991 16.8796 26.7452C15.2032 27.3337 13.1043 27.3337 8.90649 27.3337C6.50773 27.3337 5.30835 27.3337 4.35043 26.9974C2.81045 26.4568 1.59573 25.3135 1.02135 23.8641C0.664062 22.9626 0.664062 21.8337 0.664062 19.5761V11.3337Z'
        stroke='white'
        strokeWidth='1.25'
        strokeLinejoin='round'
      />
      <path
        d='M23.3333 14C23.3333 16.4546 21.3435 18.4444 18.8889 18.4444C18.0012 18.4444 16.9546 18.2889 16.0915 18.5202C15.3246 18.7256 14.7256 19.3246 14.5202 20.0915C14.2889 20.9546 14.4444 22.0012 14.4444 22.8889C14.4444 25.3435 12.4546 27.3333 10 27.3333'
        stroke='white'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.66406 7.33398H15.9974'
        stroke='white'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.66406 12.667H10.6641'
        stroke='white'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
